import { AxiosError } from "axios";

/**
 * Detects a "this federation is no longer available to you" response on the REST
 * `GET /federations/available/:id` endpoint.
 *
 * BE returns `404 NOT_FOUND` for both "id doesn't exist" and "id outside the
 * caller's available set" — same status either way so the body can't be used
 * as a discovery oracle. From the FE's perspective both cases mean "stored /
 * URL federation id is stale — clear it and fall back to me/available."
 */
export const isFederationForbiddenError = (
  error: AxiosError | Error | null | undefined
): boolean => {
  if (!error) return false;
  if (isAxiosError(error)) return error.response?.status === 404;
  return false;
};

const isAxiosError = (error: Error): error is AxiosError =>
  "isAxiosError" in error && Boolean((error as AxiosError).isAxiosError);
